import _ from 'lodash';

export const  Carousel = () => {
  const $strategiesSlider = $('.js-strategies');

  $('.js-slider').owlCarousel({
    loop: true,
    items: 3,
    dots: true,
    autoplaySpeed: 500,
    autoplayHoverPause: true,
    autoplay: 4000,
    nav: true,
    margin: 30,
    responsive: {
      0: {
        items: 1,
        autoHeight: true
      },
      992: {
        autoHeight: false,
        items: 3
      }
    },
  });

  $strategiesSlider.owlCarousel({
    loop: true,
    items: 1,
    dots: true,
    autoplay: false,
    nav: true,
    margin: 0,
    animateOut: 'slideOutUp',
    animateIn: 'slideInUp',
    smartSpeed: 1000,
    autoHeight: true
  });

  const sliderFunc = _.throttle((delta) => {
    if (delta > 0) {
      $strategiesSlider.trigger('next.owl');
    } else {
      $strategiesSlider.trigger('prev.owl');
    }
  }, 2000, { 'trailing': false });

  $strategiesSlider.on('mousewheel', '.owl-stage', function (e) {
    sliderFunc(e.originalEvent.deltaY);
    e.preventDefault();
  });
};
